/**
 * Site configuration utility
 * Detects site type based on domain and provides site-specific configuration
 */

export const SiteType = {
  CS: 'cs',
  R6: 'r6',
};

export const DefaultRoutes = {
  [SiteType.CS]: '/2026/singapore',
  [SiteType.R6]: '/2026/salt-lake-city',
};

/**
 * Detect site type based on domain
 * @returns {string} Site type (CS or R6)
 */
export const getSiteType = () => {
  if (typeof window === 'undefined') {
    return SiteType.CS; // Default for SSR
  }

  const hostname = window.location.hostname;

  // Check if it's an R6 domain
  if (hostname.includes('r6') || hostname.includes('rainbow') || hostname === 'r6.majors.im') {
    return SiteType.R6;
  }

  // Default to CS
  return SiteType.CS;
};

/**
 * Get site-specific configuration
 * @returns {Object} Site configuration
 */
export const getSiteConfig = () => {
  const siteType = getSiteType();

  const configs = {
    [SiteType.CS]: {
      type: SiteType.CS,
      name: 'Majors',
      subtitle: 'CS:GO & CS2 Major Simulator',
      title: 'Major Matchups - CS2 Major Simulator',
      description: 'Simulate CS2 Major Swiss rounds, pickems, bracket paths, and playoff outcomes.',
      defaultRoute: DefaultRoutes[SiteType.CS],
      siteUrl: 'https://majors.im',
      ogImage: '/og/major-matchups-cs.png',
      keywords: 'CS2 Major simulator, Counter-Strike Major, Swiss bracket, pickems, Major matchups',
      analyticsDomain: 'majors.im',
      colorScheme: 'cs',
      themeColor: '#1f7ac0',
    },
    [SiteType.R6]: {
      type: SiteType.R6,
      name: 'R6 Majors',
      subtitle: 'Rainbow Six Siege Major Simulator',
      title: 'R6 Major Matchups - Rainbow Six Siege Major Simulator',
      description: 'Simulate Rainbow Six Siege Major matchups, Swiss picks, playoff paths, and finals brackets.',
      defaultRoute: DefaultRoutes[SiteType.R6],
      siteUrl: 'https://r6.majors.im',
      ogImage: '/og/r6-salt-lake-2026.png',
      keywords: 'Rainbow Six Siege Major simulator, R6 Major, BLAST R6 Major, Swiss bracket, R6 matchups',
      analyticsDomain: 'r6.majors.im',
      colorScheme: 'r6',
      themeColor: '#dd372d',
    },
  };

  return configs[siteType] || configs[SiteType.CS];
};

/**
 * Check if current site is CS - 
 * @returns {boolean}
 */
export const isCSSite = () => getSiteType() === SiteType.CS;

/**
 * Check if current site is R6
 * @returns {boolean}
 */
export const isR6Site = () => getSiteType() === SiteType.R6;
